/**
 * SearchBlock Component
 * 
 * Adds a search input for filtering menu items.
 * Search functionality is handled at the parent renderer level.
 */

import React, { memo } from 'react';
import { cn } from '@/lib/utils';
import { SearchBlockProps } from '@/types/menuBuilder';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SearchBlockComponentProps {
  props: SearchBlockProps;
  isPreview?: boolean;
  onSearch?: (query: string) => void;
  searchQuery?: string;
}

export const SearchBlock = memo(function SearchBlock({
  props,
  isPreview = false,
  onSearch,
  searchQuery = '',
}: SearchBlockComponentProps) {
  const { placeholder, style } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch?.(e.target.value);
  };

  const baseClasses = 'w-full transition-all duration-200';
  
  const styleClasses = {
    rounded: 'rounded-full px-4',
    square: 'rounded-lg',
    minimal: 'rounded-none border-x-0 border-t-0 bg-transparent focus-visible:ring-0',
  };

  return (
    <div className="p-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        <Input
          type="text"
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleChange}
          disabled={isPreview && !onSearch}
          className={cn(baseClasses, styleClasses[style], 'pl-10')}
        />
      </div>
    </div>
  );
});

export default SearchBlock;
